/**
 * 当前系统默认颜色色板
 */
export const COLOR_PALETTE = [
  "rgba(84, 145, 255, 1)",
  "rgba(255, 153, 124, 1)",
  "rgba(172, 228, 145, 1)",
  "rgba(255, 219, 105, 1)",
  "rgba(124, 221, 255, 1)",
  "rgba(157, 141, 255, 1)",
];

export const COLOR_PALETTE_MORE = [
  "rgba(84, 145, 255, 1)",
  "rgba(118, 167, 255, 1)",
  "rgba(169, 200, 255, 1)",
  "rgba(157, 141, 255, 1)",
  "rgba(176, 164, 255, 1)",
  "rgba(206, 198, 255, 1)",
  "rgba(124, 221, 255, 1)",
  "rgba(150, 228, 255, 1)",
  "rgba(189, 238, 255, 1)",
  "rgba(172, 228, 145, 1)",
  "rgba(188, 233, 167, 1)",
  "rgba(214, 242, 200, 1)",
  "rgba(255, 219, 105, 1)",
  "rgba(255, 153, 124, 1)",
  "rgba(255, 173, 150, 1)",
  "rgba(255, 204, 189, 1)",
  "rgba(253, 113, 177, 1)",
  "rgba(253, 162, 214, 1)",
  "rgba(93, 112, 146, 1)",
  "rgba(194, 200, 213, 1)",
];

export const COLOR_LIGHT_PALETTE_MORE = [
  "rgba(84, 145, 255, 0.25)",
  "rgba(118, 167, 255, 0.25)",
  "rgba(169, 200, 255, 0.25)",
  "rgba(157, 141, 255, 0.25)",
  "rgba(176, 164, 255, 0.25)",
  "rgba(206, 198, 255, 0.25)",
  "rgba(124, 221, 255, 0.25)",
  "rgba(150, 228, 255, 0.25)",
  "rgba(189, 238, 255, 0.25)",
  "rgba(172, 228, 145, 0.25)",
  "rgba(188, 233, 167, 0.25)",
  "rgba(214, 242, 200, 0.25)",
  "rgba(255, 219, 105, 0.25)",
  "rgba(255, 153, 124, 0.25)",
  "rgba(255, 173, 150, 0.25)",
  "rgba(255, 204, 189, 0.25)",
  "rgba(253, 113, 177, 0.25)",
  "rgba(253, 162, 214, 0.25)",
  "rgba(93, 112, 146, 0.25)",
  "rgba(194, 200, 213, 0.25)",
];

/**
 * 当前系统默认颜色色板
 */
export const COLOR_LIGHT_PALETTE = [
  "rgba(84, 145, 255, 0.25)",
  "rgba(255, 153, 124, 0.25)",
  "rgba(172, 228, 145, 0.25)",
  "rgba(255, 219, 105, 0.25)",
  "rgba(124, 221, 255, 0.25)",
  "rgba(157, 141, 255, 0.25)",
];

/**
 * 进度条颜色
 */
export const PROGRESS_BAR_COLOR = [
  "rgba(84, 145, 255, 1)",
  "rgba(84, 145, 255, 0.50)",
];
/**
 * 当前系统默认主题
 */
export const CHART_THEME = {
  color: COLOR_PALETTE,
};
